import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { PagePermission } from "../enums/permissions.enum";

type PermissionState = {
    page: PagePermission
    setPagePermission: (state: PagePermission) => void;
}

export const usePermissionStore = create<PermissionState>(
        (set) => ({
            page: {
                add: false,
                delete: false,
                edit: false,
                view: false,
            },
            setPagePermission: (state) => {
                set(_ => {
                    return { page: state }
                })
            }
        })
)
